import { Skeleton } from "@/components/ui";

interface RxHistoryListSkeletonProps {
  count?: number;
}

export const RxHistoryListSkeleton = ({
  count = 5,
}: RxHistoryListSkeletonProps) => {
  return (
    <div
      className="flex flex-col gap-2 w-full"
      data-testid="rx-history-list-skeleton"
    >
      {Array.from({ length: count }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <div key={i} className="rounded-lg border p-3 flex flex-col gap-1">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-full" />
        </div>
      ))}
    </div>
  );
};
